export default __webpack_public_path__ + "static/media/khp-pattern-sm.db7f5b42.png";